<template>
  <div class="cencent" style="display: flex">
    <div style="width: 200px;height: 100%;background-color: #1D1E1F;height: 100%;">
      <img src="../../../assets/login/changju.png" style="width: 200px">
      <el-menu default-active="1-1" class="el-menu-vertical-demo" background-color="#1D1E1F" text-color="#fff"
        active-text-color="#ffd04b" @open="handleOpen" @close="handleClose">
        <el-submenu index="1">
          <template slot="title">
            <i class="el-icon-location"></i>
            <span>账号管理</span>
          </template>
          <el-menu-item index="1-1" @click="setstatus(0)">账号管理</el-menu-item>
        </el-submenu>
        <el-submenu index="2">
          <template slot="title">
            <i class="el-icon-setting"></i>
            <span>系统设置</span>
          </template>
          <el-menu-item index="2-1" @click="setstatus(1)">一级菜单</el-menu-item>
          <el-menu-item index="2-2" @click="setstatus(2)">二级菜单</el-menu-item>
          <!--<el-menu-item index="2-3" @click="setstatus(4)">字段库</el-menu-item>-->
          <!--<el-menu-item index="2-4" @click="setstatus(3)">权限表</el-menu-item>-->
        </el-submenu>
      </el-menu>
    </div>
    <!-- 右侧主体 -->
    <div>
      <!-- 账号管理的右侧窗体 -->
      <acount v-if="status == 0"></acount>
      <!-- 一级菜单的右侧窗体 -->
      <class_v1 v-if="status == 1"></class_v1>
      <!-- 二级菜单的右侧窗体 -->
      <menu_v v-if="status == 2"></menu_v>
      <!-- 字段库的右侧窗体 -->
      <field v-if="status == 4"></field>
    </div>
  </div>
</template>

<script>
import field from "./field";
import acount from "./index"
import menu_v from "./menu";
import class_v1 from "./class_v1";
export default {
  data() {
    return {
      status: 0
    }
  },
  components: {
    acount,
    field,
    menu_v,
    class_v1,
  },
  name: "home",
  methods: {
    setstatus(status) {
      this.status = status
    },
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/page/module/admin/home.vue